import { lazy } from 'react'
import { t } from 'ttag'

const Edit = lazy(async () => {
  const { Edit: EditModule } = await import(
    /* webpackChunkName: "personalprofile-edit" */ './components/edit'
  )

  return {
    default: EditModule
  }
})
// TODO: Move more routes under /personalprofile here
const routes = [
  {
    path: '/personalprofile/edit',
    authenticated: true,
    name: t`Personal Information`,
    render(props) {
      return <Edit {...props} />
    }
  }
]

export { routes }
